import React from "react";
import {easyStart as easyStartData } from "../../data";
import {EasyStartSingle,SectionTitle} from "../../components/";


const EasyStart = () => {
  return (
    <div className="dg__earn__money__area earn__money-space section-padding--xlg bg--white">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            {/* section title */}
            <SectionTitle
              title="Easy way to start"
              text="There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour."
            />
          </div>
        </div>
        <div className="earn__money__wrap">
          {easyStartData &&
            easyStartData.map((single, key) => {
              return <EasyStartSingle data={single} key={key} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default EasyStart;
